import { useState } from 'react';
import { api, errorMessage } from '../../shared/api/client';
import { Alert, Button } from '../../shared/ui/components';

/** Aviso "confirma tu correo" con opción de reenviar el enlace. */
export function EmailVerificationNotice({ email, children }: { email: string; children?: React.ReactNode }) {
  const [state, setState] = useState<{ busy: boolean; message: string | null; error: string | null }>({ busy: false, message: null, error: null });

  async function resend() {
    setState({ busy: true, message: null, error: null });
    try {
      await api.post('/identity/me/email-verification');
      setState({ busy: false, message: `Te enviamos un nuevo enlace a ${email}.`, error: null });
    } catch (e) {
      setState({ busy: false, message: null, error: errorMessage(e) });
    }
  }

  return (
    <div className="notice">
      <p>
        <strong>Confirma tu correo.</strong> Enviamos un enlace a <strong>{email}</strong>. {children}
      </p>
      {state.message ? <Alert tone="success">{state.message}</Alert> : null}
      {state.error ? <Alert>{state.error}</Alert> : null}
      <Button variant="secondary" busy={state.busy} onClick={resend}>
        Reenviar enlace
      </Button>
    </div>
  );
}
